import { memo } from 'react';
import LibTasksTableMultiselect, {
  TasksTableMultiselectProps,
} from '@lib/components/TaskCompletions/TasksTableMultiselect/TasksTableMultiselect';
import useTasksTableMultiselectFilterLoadOptions from 'utils/fetch/hooks/useTasksTableMultiselectFilterLoadOptions';

function TasksTableMultiselect(
  props: Omit<TasksTableMultiselectProps, 'filterLoadOptions'>,
) {
  const filterLoadOptions = useTasksTableMultiselectFilterLoadOptions();
  return (
    <LibTasksTableMultiselect
      {...props}
      filterLoadOptions={filterLoadOptions}
    />
  );
}

export default memo(TasksTableMultiselect);
